import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';

export type DatePickerMode = 'absolute' | 'since' | 'last';
export interface FixedDateTimeRange {
  type: 'absolute';
  startAfter: dayjs.Dayjs | null;
  endBefore: dayjs.Dayjs | null;
}

export enum TimePeriodUnit {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export interface LastDateTimeRange {
  type: 'last';
  unit: TimePeriodUnit;
  value?: number;
}

export interface SinceDateTimeRange {
  type: 'since';
  startAfter: dayjs.Dayjs | null;
}

export type DateTimeRange =
  | FixedDateTimeRange
  | LastDateTimeRange
  | SinceDateTimeRange;

export type TimeStampDateTimeRange =
  | FixedTimeStampDateTimeRange
  | LastDateTimeRange
  | SinceTimeStampDateTimeRange;

interface FixedTimeStampDateTimeRange {
  startAfter: number | undefined;
  endBefore: number | undefined;
  type: 'absolute';
}
interface SinceTimeStampDateTimeRange {
  startAfter: number | undefined;
  type: 'since';
}

export interface CalendarPickerProps {
  dateRange: DateRange<dayjs.Dayjs | null>;
  timeRange: DateTimeRange | null;
  onChange: (timeRange: DateTimeRange) => void;
  shouldHideDisplayModes?: boolean;
}
